import { useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { testsApi } from "@/api/tests.api";

const trashKey = ["qualification-tests", "trash"] as const;

export function useTestSubmissionRecycleBin(isSuperAdmin: boolean) {
  const queryClient = useQueryClient();
  const trash = useInfiniteQuery({
    queryKey: trashKey,
    queryFn: ({ pageParam }) => testsApi.listTrashedSubmissions(50, pageParam ?? undefined),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    enabled: isSuperAdmin,
  });
  const refreshActiveTests = async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ["tests"] }),
      queryClient.invalidateQueries({ queryKey: ["admin-todo"] }),
      queryClient.invalidateQueries({ queryKey: ["moderator-todo"] }),
      queryClient.invalidateQueries({ queryKey: trashKey }),
    ]);
  };
  const moveToTrash = useMutation({
    mutationFn: (input: { id: string; reason: string; expectedVersion: number }) =>
      testsApi.trashSubmission(input.id, input.reason, input.expectedVersion),
    onSuccess: refreshActiveTests,
  });
  const restore = useMutation({
    mutationFn: (id: string) => testsApi.restoreSubmission(id),
    onSuccess: refreshActiveTests,
  });

  return {
    items: trash.data?.pages.flatMap((page) => page.items) ?? [],
    isLoading: trash.isLoading,
    hasError: trash.isError,
    hasMore: trash.hasNextPage,
    isLoadingMore: trash.isFetchingNextPage,
    loadMore: trash.fetchNextPage,
    moveToTrash,
    restore,
  };
}
